import React from 'react'
import Fade from 'react-reveal/Fade'
export default function PageContainer({ children }) {
    return (
        <Fade duration={300}>
            {children}
        </Fade>
    )
}
